import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import AdminPage from './AdminPage';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';

export default class AdminStateGroupPage extends PageComponent {

  static PageInfo = {

    path: "/Admin/StateGroup",
    parent: AdminPage,
    name: "menu.stategroups",
    access: { 1: true },
    permission: { "CONFIGURATION_REGIONAL_LIST": true },
    icon: "globe-americas"
  }

  constructor(props) {
    super(props);
    this.state.loading = true;
    this.state.isModalVisible = false;
    this.state.brands = null;
    this.state.selectedBrand = null;
    this.state.modalInitializing = false;
    this.state.modalError = null;
    this.state.modalLoading = false;
    this.state.group = null;
  }

  componentDidMount() {

    Connection.Secure(Connection.service + 'StateGroup/List')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  addStateGroup() {
    this.setState({ modalLoading: true });

    Connection.Secure(Connection.service + 'StateGroup/New',
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, "body": JSON.stringify({ label: this.state.group, brand: { keyConstant: this.state.selectedBrand } })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.text().then((data) => {
            this.setState({ isModalVisible: false, modalLoading: false }, () => this.props.history.push('/Admin/StateGroup/' + data));
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  openModal() {
    this.setState({
      isModalVisible: true, modalInitializing: true,
      modalLoading: false,
      modalError: null
    });
    Connection.Secure(Connection.service + 'Brand/List')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ brands: data, modalInitializing: false }));
          });
        else this.setState({ error: true, modalInitializing: false });
      })
      .catch((error) => {
        this.setState({ error: true, modalInitializing: false });
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  {this.state.data.map((item) =>
                    <Link to={"/Admin/StateGroup/" + item.keyConstant} className="generics_listing_item" >
                      <FontAwesomeIcon icon="map-marked-alt" className="generics_listing_item_icon" />
                      <div className="generics_listing_content" >
                        <div className="generics_listing_item_title" >{item.label}</div>
                        <div className="generics_listing_item_description" >{item.brand.label}</div>
                      </div>
                    </Link>
                  )}
                </div>
          }

          <div className="generics_floatinbtn" onClick={() => this.openModal()}>
            <FontAwesomeIcon className="generics_floatinbtn_icon" icon="plus" />
          </div>

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible}
          // onHide={handleClose}
          >
            <div>
              {
                this.state.modalInitializing == false ?
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("adminstategroup.newheader")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {
                        Array.isArray(this.state.brands) ?
                          <MaskedInput type="select" icon="tag" label={Labels.GetLabel("clientsnew.brandname")} notnull={true} onValid={(value) => this.setState({ selectedBrand: parseInt(value[0]) })}
                            onInvalid={(value) => this.setState({ selectedBrand: null })} name="keyConstant,label" data={this.state.brands} placeholder={Labels.GetLabel("generic.select")} />

                          : null
                      }
                      <MaskedInput type="text" label={Labels.GetLabel("adminstategroup.newlabel")} notnull={true} onValid={(value) => this.setState({ group: value })}
                        onInvalid={(value) => this.setState({ group: null })} />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                      <Button variant="primary" disabled={this.state.group == null || this.state.selectedBrand == null} onClick={() => this.addStateGroup()}>
                        {Labels.GetLabel("adminstategroup.savebtn")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
                  : <div>
                    {Labels.GetLabel("adminstategroup.saving")}
                  </div>
              }
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
}